import { AxiosRequest } from "../common/axios-request"
import { CREATE_SELLING_PRODUCT_STOCK, DELETE_SELLING_PRODUCT_DETAILS, GET_ALL_SELLING_PRODUCT_STOCK_LIST, GET_SELLING_PRODUCT_DETAILS, GET_SELLING_PRODUCT_ORDER_HISTORY, GET_SELLING_PRODUCT_STOCK_LIST, GET_SINGLE_SELLING_PRODUCT_HISTORY, UPDATE_SELLING_PRODUCT_DETAILS } from "../common/constant"

const GetAllSellingStockList = (id: string, isActive: string = "") => {
    return AxiosRequest.get(GET_ALL_SELLING_PRODUCT_STOCK_LIST(id, isActive))
}

const GetSellingStockList = () => {
    return AxiosRequest.get(GET_SELLING_PRODUCT_STOCK_LIST)
}

const GetSellingProductDetails = (id: string) => {
    return AxiosRequest.get(GET_SELLING_PRODUCT_DETAILS.replace(":id", id))
}

const CreateSellingProduct = (payload: any) => {
    return AxiosRequest.post(CREATE_SELLING_PRODUCT_STOCK, payload)
}

const UpadateSellingProductDetails = (id: string, payload: any) => {
    return AxiosRequest.put(UPDATE_SELLING_PRODUCT_DETAILS.replace(":id", id), payload)
}

const DeleteSellingProduct = (id: string) => {
    return AxiosRequest.delete(DELETE_SELLING_PRODUCT_DETAILS.replace(":id", id))
}

const GetSingleSellingProductHistory = (id: string, year: string, month: string) => {
    return AxiosRequest.get(GET_SINGLE_SELLING_PRODUCT_HISTORY(id, year, month))
}

const GetSellingProductOrderHistory = (id: string, year: string, month: string) => {
    return AxiosRequest.get(GET_SELLING_PRODUCT_ORDER_HISTORY(id, year, month))
}

export { GetSingleSellingProductHistory, GetAllSellingStockList, GetSellingStockList, GetSellingProductDetails, CreateSellingProduct, UpadateSellingProductDetails, DeleteSellingProduct, GetSellingProductOrderHistory }